<div
  class="flex flex-col items-center justify-center gap-2"
  role="status"
  aria-live="polite"
  aria-busy="true"
  [attr.aria-label]="text">
  <ng-lottie
    [options]="hourglassAnimationOptions"
    class="mx-auto h-16 w-16">
  </ng-lottie>
  <span class="text-sm text-gray-500">{{ text }}</span>
</div>
